import {useTranslation} from "react-i18next";
import {IdlocaGeneric} from "./IdlocaGeneric";
import {FC} from "react";

interface ILocaleProps {
    localeId: IdlocaGeneric;
    replacements?: Record<string, string | number>;
}

export const Locale: FC<ILocaleProps> = ({localeId, replacements = {}}) => {
    const {t} = useTranslation();
    const translated = t(localeId, {...replacements});
    return <>{translated}</>;
};

